export const AXIS_LABELS_SETTINGS = {
  color: true,
  fontSize: true,
  bold: true,
  italic: true,
  underline: false,
  alignment: false,
};

export const AXIS_TITLES_SETTINGS = {
  color: true,
  fontSize: true,
  bold: true,
  italic: true,
  underline: false,
  alignment: false,
};

export const AVAILABLE_FONT_SIZES = [9, 10, 11, 12, 13, 14, 15, 16];
